import { useEffect, useState } from 'react';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import styles from './filter-boolean-menu.module.scss';
import { NumberActions } from '@monorepo/tools/src/lib/utils/number';
import { IDebugProps } from '@monorepo/tools/src/lib/interfaces/debug';
import { DataAttribute, generateDataAttrs } from '@monorepo/tools/src/lib/models/data-attr.model';
import { PrimaryButton, SecondaryButton } from '../../buttons/buttons';

interface IFilterBooleanMenu {
	title: string;
	onApply: (action: NumberActions.Equals, value: boolean) => void;
	onCancel: () => void;
	defaultAction?: NumberActions.Equals;
	defaultValue?: boolean;
	inputClassNames?: string;
	debugProps?: IDebugProps;
}

export const FilterBooleanMenu = (props: IFilterBooleanMenu) => {
	const { title, onCancel, defaultValue, debugProps, onApply } = props;
	const [filterValue, setFilterValue] = useState<boolean | undefined>(defaultValue);
	const { dataAttrs } = debugProps || {};

	useEffect(() => {
		if (filterValue === true) {
			setFilterValue(true);
		} else if (filterValue === false) {
			setFilterValue(false);
		}
	}, [filterValue]);

	return (
		<div className={styles.wrapper} {...generateDataAttrs(dataAttrs)}>
			<div className={styles.title}>
				{title}
				<Icon isMFP={true} className={styles.closeButton} onClick={onCancel}>
					x-close
				</Icon>
			</div>
			{/* <div className={styles.actionsDiv}>Actions</div> */}
			<div className={styles.content}>
				<div>
					<label onClick={() => setFilterValue(true)} className={styles.checkboxLabel}>
						Yes
					</label>
					<input
						className={styles.checkboxInput}
						type="checkbox"
						checked={filterValue === true}
						onChange={() => {
							setFilterValue(true);
						}}
						autoFocus={true}
						data-id="filter_value_checkbox"
					/>
				</div>
				<div>
					<label onClick={() => setFilterValue(false)} className={styles.checkboxLabel}>
						No
					</label>
					<input
						className={styles.checkboxInput}
						type="checkbox"
						checked={filterValue === false}
						onChange={() => {
							setFilterValue(false);
						}}
						autoFocus={true}
						data-id="filter_value_checkbox_no"
					/>
				</div>
			</div>
			<div className={`${styles.actions}`}>
				<div className={styles.action}>
					<SecondaryButton
						className={`${styles.actionButton} ${styles.cancelButton}`}
						onClick={onCancel}
						debugProps={{ dataAttrs: [new DataAttribute('id', 'filter_menu_cancel_button')] }}>
						Cancel
					</SecondaryButton>
				</div>
				<div className={styles.action}>
					<PrimaryButton
						className={styles.actionButton}
						onClick={() => {
							if (filterValue || filterValue === false) {
								onApply(NumberActions.Equals, filterValue);
							}
						}}
						debugProps={{ dataAttrs: [new DataAttribute('id', 'filter_menu_apply_button')] }}>
						Apply
					</PrimaryButton>
				</div>
			</div>
		</div>
	);
};
